module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8hgFs"))).then(() => parcelRequire('9Lwss'));